export function voiceStyleSliderAccessibilityText(value) {
    if (value === 1) {
        return 'Tone of Salesman.';
    }
    if (value === 2) {
        return 'Tone of the brand.';
    }
}